var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icon_tick1_24x24"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 58",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.88586 12.8573L2 7.94102L3.96978 5.98439L6.88586 8.89321L12.4116 3.3335L14.381 5.31554L6.88586 12.8573Z",
  fill: "white"
}))));
export default SvgIconTick;